module.exports = __webpack_public_path__ + "img/item_icon4.60c6aae9.png";